import { render, staticRenderFns } from "./RewardStep.vue?vue&type=template&id=40b5d2ae&scoped=true"
import script from "./RewardStep.vue?vue&type=script&lang=js"
export * from "./RewardStep.vue?vue&type=script&lang=js"
import style0 from "./RewardStep.vue?vue&type=style&index=0&id=40b5d2ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40b5d2ae",
  null
  
)

export default component.exports